import { Lightbulb } from "@faire/web/slate/icons/foundation/Lightbulb";
import React from "react";
export var DEFAULT_OTHER_NODE = function DEFAULT_OTHER_NODE(strictLocalize) {
  return {
    id: "DefaultOther",
    label: OTHER_NODES_LABEL(strictLocalize),
    level: 3,
    sidebarTitle: strictLocalize({
      id: "bPl2/w",
      defaultMessage: [{
        "type": 0,
        "value": "Autre problème"
      }]
    }),
    icon: /*#__PURE__*/React.createElement(Lightbulb, {
      fontSize: "24px",
      color: "faireBlack"
    })
  };
};
export var OTHER_NODES_LABEL = function OTHER_NODES_LABEL(strictLocalize) {
  return strictLocalize({
    id: "W+Z+Pt",
    defaultMessage: [{
      "type": 0,
      "value": "Autre"
    }]
  });
};